import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "../../../../assets/styles/ButtonStyle";
import { Sub2 } from "../../../../assets/styles/Typography";
import { palette } from "../../../../assets/styles/Palette";
import { updateInfoBoardContentOnServer } from "../../../../utils/indexedDB";

const MoleculeEduInfoTypeSelectPopup = ({ customerId, onClose, onUpdate=null,content }) => {
  const [selectedTypes, setSelectedTypes] = useState([]);

  useEffect(() => {
    if (content && Array.isArray(content.zones)) {
      setSelectedTypes(content.zones);
    } else {
      setSelectedTypes([]);
    }
  }, [content]);

  const typeOptions = [
    { value: "grade1", label: "1학년" },
    { value: "grade2", label: "2학년" },
    { value: "grade3", label: "3학년" },
    { value: "teachers_office", label: "교무실" },
    { value: "gym", label: "체육관" },
    { value: "cafeteria", label: "식당" },
    { value: "nurse_office", label: "양호실" },
    { value: "music_room", label: "음악실" },
    { value: "science_lab", label: "과학실" },
    { value: "art_room", label: "미술실" },
    { value: "auditorium", label: "강당" },
    { value: "library", label: "도서관" },
  ];

  const handleSelectionChange = (value) => {
    setSelectedTypes((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const handleSave = async () => {
    try {
      if (content && content._id) {
        await updateInfoBoardContentOnServer(content._id, { zones: selectedTypes });
      } else {
        console.error("저장할 콘텐츠 정보가 없습니다.");
      }

      if (onUpdate) {
        await onUpdate();
      }
      onClose();
    } catch (e) {
      console.error("설정 저장 실패:", e);
    }
  };

  return (
    <>
      <Overlay onClick={onClose} />
      <PopupContainer>
        <Header>
          <Heading>콘텐츠 타입 설정</Heading>
          <CloseButton onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </CloseButton>
        </Header>

        <Body>
          <SectionTitle>
            {/* <SectionTitleText>콘텐츠 순환 시간</SectionTitleText>
            <SectionDescription>각 콘텐츠가 표시되는 시간을 설정합니다</SectionDescription> */}
          </SectionTitle>
          <RadioGroup>
            {typeOptions.map((option) => (
              <RadioCard
                key={option.label}
                checked={selectedTypes.includes(option.label)}
                onClick={() => handleSelectionChange(option.label)}
              >
                <RadioCardContent>
                  <RadioCardTitle>{option.label}</RadioCardTitle>
                  <CustomCheckbox checked={selectedTypes.includes(option.label)} />
                </RadioCardContent>
                <HiddenRadioInput
                  type="checkbox"
                  name="typeSelection"
                  value={option.label}
                  checked={selectedTypes.includes(option.label)}
                  readOnly
                />
              </RadioCard>
            ))}
          </RadioGroup>
        </Body>

        <Footer>
          <Button Large Gray Fill onClick={onClose} style={{ minWidth: "90px", height: "40px" }}>
            <Sub2 color="gray700">닫기</Sub2>
          </Button>
          <Button Large Primary Fill onClick={handleSave} style={{ minWidth: "90px", height: "40px" }} disabled={selectedTypes.length === 0}>
            <Sub2 color="white">저장</Sub2>
          </Button>
        </Footer>
      </PopupContainer>
    </>
  );
};

export default MoleculeEduInfoTypeSelectPopup;

const PopupContainer = styled.div`
  width: 720px;
  max-width: 90vw;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 40px 40px 24px 40px;
  background: white;
  border-bottom: 1px solid ${palette.outlineGray};
`;

const Heading = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: ${palette.gray900};
  margin: 0;
  line-height: 1.2;
  text-align: left;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -4px;
  &:hover { background: ${palette.gray100}; }
`;

const Body = styled.div`
  padding: 24px 40px 40px 40px;
`;

const SectionTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
  margin-bottom: 16px;
`;

const SectionTitleText = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${palette.gray900};
  margin: 0;
  text-align: left;
`;

const SectionDescription = styled.p`
  font-size: 15px;
  font-weight: 400;
  color: ${palette.gray600};
  margin: 0;
  line-height: 1.4;
  text-align: left;
`;

const RadioGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

const RadioCard = styled.div`
  border: 2px solid ${({ checked }) => (checked ? "#226FFF" : "#E0E4EB")};
  background: ${({ checked }) => (checked ? "rgba(34, 111, 255, 0.02)" : "#fff")};
  border-radius: 12px;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    border-color: ${({ checked }) => (checked ? "#226FFF" : "#BCC4D0")};
    background: ${({ checked }) => (checked ? "rgba(34, 111, 255, 0.04)" : "#F7F8FA")};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
`;

const RadioCardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const RadioCardTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${palette.gray900};
`;

const CustomCheckbox = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid ${({ checked }) => (checked ? "#226FFF" : "#C8D1E1")};
  border-radius: 4px;
  position: relative;
  background: ${({ checked }) => (checked ? "#226FFF" : "#fff")};
  transition: all 0.2s ease;
  flex-shrink: 0;
  
  &::after {
    content: "";
    display: block;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    opacity: ${({ checked }) => (checked ? 1 : 0)};
  }
`;

const HiddenRadioInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

const Footer = styled.div`
  display: flex;
  gap: 16px;
  padding: 24px 40px;
  background: white;
  justify-content: center;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;
